import graphql__a31fdd87b3356e02d419 from "./__generated__/CreateInvoiceDialogCustomerAccountsQuery.graphql.ts";
import graphql__9660d630f2d367e774b0 from "./__generated__/CreateInvoiceDialogMutation.graphql.ts";import * as React from "react";
import {commitMutation, fetchQuery, graphql} from "react-relay";
import {useRelayEnvironment} from "react-relay/hooks";
import Section from "../form/Section";
import Row from "../form/Row";
import Label from "../form/Label";
import * as yup from "yup";
import FormDialog from "../dialog/FormDialog";
import type {CreateInvoiceDialogMutation} from "./__generated__/CreateInvoiceDialogMutation.graphql";
import {useNavigate} from "react-router-dom";
import asFormikField from "../abstract/asFormikField";
import AbstractCombobox from "../abstract/AbstractCombobox";
import AwesomeDebouncePromise from 'awesome-debounce-promise';
import {useErrorContext} from "../../contexts/ErrorContext";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";
import {useIntl} from "react-intl";

const customerAccountsDataProvider = (relayEnvironment) => {
    return AwesomeDebouncePromise((searchTerm: String = '') => {
        return fetchQuery(relayEnvironment, graphql__a31fdd87b3356e02d419, {searchTerm}).toPromise().then((data) => {
            if (!data) {
                return [];
            }
            //@ts-ignore
            return data.customerAccounts?.edges?.map((edge) => edge.node) || [];
        });
    }, 500);
}

type Props = {
    handleCloseDialog: () => {}
}

const CreateInvoiceDialog: React.FC<Props> = ({handleCloseDialog}) => {
    const intl = useIntl();
    const relayEnvironment = useRelayEnvironment();
    const navigate = useNavigate();
    const {addError} = useErrorContext();

    const handleSubmission = (input) => {
        commitMutationWithErrorHandling<CreateInvoiceDialogMutation>(
            relayEnvironment,
            {
                mutation: graphql__9660d630f2d367e774b0,
                variables: {
                    input: {
                        customerAccountIdentifier: input.customerAccountIdentifier?.id || null
                    }
                },
                onCompleted: (response, errors) => {
                    if (errors && errors.length > 0) {
                        console.error(errors);
                    }
                    handleCloseDialog();
                    navigate('/invoices/' + response.createInvoice?.id + '/edit')
                },
                onError: (error) => {
                    console.error(error);
                    handleCloseDialog();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToCreateInvoice'})
            }
        )
    }
    const validationSchema = yup.object().shape({
        customerAccountIdentifier: yup.object()
            .required(intl.formatMessage({id: 'validation.field.required'})),
    });

    const FormikCombobox = asFormikField(AbstractCombobox, 'customerAccountIdentifier');

    const getEntrySecondaryLabel = (customerAccount) => {
        return customerAccount?.customerNumber
    }

    return (
        <FormDialog handleCloseDialog={handleCloseDialog} handleSubmission={handleSubmission} initialValues={{}} validationSchema={validationSchema} headline={intl.formatMessage({id: 'dialog.CreateInvoiceDialog.headline'})} submitLabel={intl.formatMessage({id: 'button.create'})}>
            <Section>
                <Row>
                    <Label>{intl.formatMessage({id: 'dialog.CreateInvoiceDialog.customerAccountLabel'})}</Label>
                    <FormikCombobox getEntryId={(customerAccount) => customerAccount.id} getEntryLabel={(customerAccount) => customerAccount && customerAccount.customerName} getEntrySecondaryLabel={getEntrySecondaryLabel} dataProvider={customerAccountsDataProvider(relayEnvironment)} autoFocus={true}/>
                </Row>
            </Section>
        </FormDialog>
    )
}

export default CreateInvoiceDialog;
